import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"
import shuffle from "utils/shuffle"
import Profile from "../models/profile"

const useCollectionProfiles = ({ type, order, limit, poi } = {}) => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`
    query AllCollectionProfilesQuery {
      profiles: allCollectionProfiles(sort: { date: DESC }) {
        nodes {
          id
          order
          locale
          url
          title
          titre {
            value
          }
          firstName
          role
          type: profileType {
            slug
            title
          }
          portrait {
            alt
            localImage {
              childImageSharp {
                gatsbyImageData(width: 320)
              }
            }
          }
          poi {
            id
          }
          displayFirstnameOnly
          displayOnProfilesListOnly
        }
      }
    }
  `)

  /**
   * Get all Profiles in the current locale
   * and apply filters if needed
   */
  return React.useMemo(() => {
    let profiles = data.profiles.nodes.filter(n => n.locale === locale)

    if (type) {
      profiles = profiles.filter(
        item => item.type && item.type.some(c => c.slug === type)
      )
    }

    /**
     * filter by poi
     */
    if (poi?.id) {
      profiles = profiles.filter(item => {
        const pois = item.poi.map(p => p.id)
        return pois.includes(poi.id)
      })
    }

    switch (order) {
      case "listOrder":
        profiles.sort((a, b) => a.order - b.order)
        break

      case "random":
        profiles = shuffle(profiles)
        break

      case "oldest":
        profiles.sort((a, b) => new Date(a.date) - new Date(b.date))
        break

      case "latest":
      default:
      // nothing to do, this is the natural order
    }

    if (limit) {
      profiles = profiles.slice(0, limit)
    }

    profiles = profiles.map(profile => new Profile(profile))

    return profiles
  }, [data, locale, type, order, limit, poi?.id])
}

export default useCollectionProfiles
